<template> 
  <section>
    <div>
      <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
        <h5><b>About Professional Insurance</b></h5>
      </div>
      <div style="padding:10px 100px 10px 20px;font-size:13px">
        <p>
          Professional Insurance Corporation Zambia PLC is the largest General Insurance Company on the Zambian Market. The Corporation opened its doors to the public on 9th July 1992 with only two offices, in Ndola and Lusaka. The Corporation has grown over the years with an extensive branch network and several partnerships throughout the country.
        </p>
        <p>
          The Corporation has continued to distinguish itself on the Zambian Insurance Market owing to a strong and vibrant team of professionals with the highest competences at the core of the Company’s operations. This team of dedicated, talented, enthusiastic and experienced employees is our source of strength and remains our key resource. 
        </p>
        <p>  
          With these key competences, the company has been able to prudently offer various risk solutions in the short term Insurance space. This has been supported by a world class team of reinsurers which include Munich Re, Swiss Re, Hannover Re, SCOR and other regional groups, namely Africa Re, PTA Re for Reinsurance arrangements. The Company has also shown its Underwriting prowess by writing all classes of general insurance business being Fire, Accident, Motor, Engineering, Marine, Aviation and Incidental Risks.
        </p>
      </div>
      <div>
        <h6 style="padding:20px"><b>Board of Directors</b></h6>
        <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/wambulawae.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MS I.S. WAMBULAWAE</b>
                    <P>Chairperson</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/siame.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MR. MOSES SIAME</b>
                    <P>Managing Director/CEO</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/craven.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MRS. J. CRAVEN</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/schultz.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MRS. M. SCHULTZ</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/sombe.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MR. R. SOMBE</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/williams.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MR. S. WILLIAMS</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/de_wit.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MR. LEON DE WIT</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
              <v-flex xs3 mb-2>
                <v-card>
                  <v-img src="../assets/board/musiwa.png" height="100%"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <b>MS I.S. WAMBULAWAE</b>
                    <P>Non-Executive Director</p>
                  </div>                
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
      </div>
      <div style="text-align:center">
        <h5 style="padding:20px"><b>Executive Management</b></h5>
        <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 mb-2>
                <v-card>
                  <v-img :src="require('../assets/management.jpg')" aspect-ratio="2"></v-img>                
                  <div style="font-size: 12px;padding-left:20px;padding-right:20px">
                    <P>From Left to Right: <b>Mr. Ian Musweu</b> (Head-Risk & Internal Audit); <b>Mrs. Yvonne Majata</b> (COO); <b>Mr. Paul Simukoko</b> (Head-Human Resource); <b>Mr. Webster Twaambo</b> (Head-Branch Operations); <b>Mr. Mwangala Mwiya</b> (Head-ICT); <b>Mr. Moses Siame</b> (CEO); <b>Ms. Cynthia Simeza</b> (Head-Claims) <b>Mrs. Patricia Chuulu</b> (Head-Reinsurance) <b>Mr. William Simfukwe</b> (CFO)</p>
                  </div>                
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
      </div>
    </div>
  </section>
</template>
<script>  
  export default {
  name: 'About'
}
</script>
